'use strict';

if (window.jQuery) {
    $.fn.isInViewport = function (offset) {
        if (!this.length) {
            return false;
        }
        const elementTop = this.offset().top;
        const elementBottom = elementTop + this.outerHeight();
        const $window = $(window);
        const viewportTop = $window.scrollTop();
        const viewportBottom = viewportTop + $window.height();

        return elementBottom > viewportTop + (offset || 0) && elementTop + (offset || 0) < viewportBottom;
    };

    // params
    // toggleClass - required
    // triggerSelector - optional. the selector for the element that triggers the event handler. defaults to the child
    //                   elements of the list.
    // eventName - optional. defaults to 'click'
    $.fn.toggledList = function (options) {
        if (!options.toggleClass) {
            return this;
        }
        var list = this;
        return list.on(options.eventName || 'click', options.triggerSelector || list.children(), function (e) {
            e.preventDefault();
            var classTarget = options.triggerSelector ? $(this).parent() : $(this);
            classTarget.toggleClass(options.toggleClass);
            // execute callback if exists
            if (options.callback) {
                options.callback();
            }
        });
    };

    $.fn.syncHeight = function () {
        var arr = $.makeArray(this);
        arr.sort(function (a, b) {
            return $(a).height() - $(b).height();
        });
        return this.height($(arr[arr.length - 1]).height());
    };

    /**
     * Gets all descendant elements that are currently in the navigation index.
     * @returns {Object} A jQuery object containing all descendant elements which are both focusable and tabbable.
     */
    $.fn.findTabbable = function () {
        var $focusable = $(this).find('input, select, textarea, button, a[href], [tabindex]');

        var $tabbable = $focusable.filter(function () {
            var $element = $(this);
            var tabIndex = $element.attr('tabindex');

            if ($element.is(':hidden')) {
                return false;
            }

            if ($element.is('[disabled]')) {
                return false;
            }

            if (tabIndex != null && tabIndex < 0) {
                return false;
            }

            return true;
        });

        return $tabbable;
    };

    /**
     * Focuses on the element without scrolling to it, even if it is outside the viewport.
     */
    $.fn.focusWithoutScrolling = function () {
        var x = $(document).scrollLeft();
        var y = $(document).scrollTop();
        this.focus();
        window.scrollTo(x, y);
        return this; // chainability
    };

    /**
     * Generates unique id.
     */
    $.fn.setUniqueId = function () {
        const uniqueId = Math.random().toString(36).substr(2, 9);

        this.attr('id', uniqueId);

        return this;
    };
}
